import { type ExpectedQueryParams, type IPayAppComponentProps, type MetaInfo } from '../../types/PayApp';
import { type WixIdentities } from '../../types/WixIdentities';
import { globals } from '../../utils/globals';
import { getPayAppQueryParams } from '../../utils/getPayAppQueryParams';
import { isValidLocale } from '../../utils/locale';
import { enrichErrorReports, trackError } from '../../utils/errorReporter';

const getInstanceValue = (key: string): string => window.Wix?.Utils?.getInstanceValue(key);

const getMetaInfo = (): MetaInfo => {
  const wixIdentities: WixIdentities = window.__WIX_IDENTITIES__ || {};

  return {
    msid: wixIdentities.metaSiteId || getInstanceValue('metaSiteId'),
    appId: wixIdentities.appDefinitionId || getInstanceValue('appDefId'),
    appInstanceId: wixIdentities.appInstanceId || getInstanceValue('instanceId'),
    visitorId: wixIdentities.visitorId || getInstanceValue('aid'),
    siteMemberId: wixIdentities.siteMemberId || getInstanceValue('uid'),
  };
};

const getValidDateNumberFormat = (locale?: string): string =>
  isValidLocale(locale, {
    messagePrefix: `getValidDateNumberFormat: Locale argument ${locale} is invalid`,
  })
    ? locale
    : globals.locale;

export const buildPropsFromEnv = (): IPayAppComponentProps => {
  let metaInfo: MetaInfo;

  try {
    metaInfo = getMetaInfo();
  } catch (error) {
    trackError(error, {
      messagePrefix: 'buildPropsFromEnv: Failed to get Meta info',
    });
  }

  const queryParams: ExpectedQueryParams = getPayAppQueryParams();
  const dateNumberFormat = getValidDateNumberFormat(queryParams.dateNumberFormat);

  enrichErrorReports({
    locale: globals.locale,
    userId: metaInfo.visitorId,
    msId: metaInfo.msid,
    siteMemberId: metaInfo.siteMemberId,
    snapshotId: queryParams.snapshotId,
    deviceType: queryParams.deviceType,
    dateNumberFormat,
    viewMode: queryParams.viewMode,
    allowManualPayment: queryParams.allowManualPayment,
    forceSkipUserInfoPage: queryParams.forceSkipUserInfoPage,
    skipContactCreation: queryParams.skipContactCreation,
  });

  return {
    loadInfo: globals.loadInfo,
    biLoggerTimestamp: globals.loadInfo ? globals.loadInfo.kickoffStartTime : 0,
    ...queryParams,
    ...metaInfo,
    dateNumberFormat,
    locale: globals.locale,
  };
};
